import {
  Box,
  Button,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useMediaQuery,
  withStyles,
  WithStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { connect, ConnectedProps } from "react-redux";
import { styles } from "./styles";
import ReactivateIcon from "@material-ui/icons/Refresh";
import EditIcon from "@material-ui/icons/EditOutlined";
import VisibilityIcon from "@material-ui/icons/VisibilityOutlined";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import IOSSwitch from "../IOSSwitch";

import IconCancel from "../../../../assets/iconos/cancel.svg";
import IconReactivate from "../../../../assets/iconos/reactivate.svg";
import { useNavigate } from "react-router-dom";
import { Service } from "../../types";

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({});
interface OwnProps {
  services: Service[];
  onDeleteApp: (id: number) => void;
  onChangeMuestraMobile: (id: number, value: boolean) => void;
  onChangeMuestraPanel: (id: number, value: boolean) => void;
}

const connector = connect(mapStateToProps, mapDispatchToProps);
type PublicProps = OwnProps;
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PublicProps & PropsFromRedux & WithStyles<typeof styles>;

const TableServices: React.FC<Props> = ({
  classes,
  services,
  onDeleteApp,
  onChangeMuestraMobile,
  onChangeMuestraPanel,
}) => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<Service[]>([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [deleteModal, setDeleteModal] = useState(false);
  const [reactivateModal, setReactivateModal] = useState(false);
  const [selectedService, setSelectedService] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const isSmallDevice = useMediaQuery("(max-width:414px)");
  const currentRows = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  useEffect(() => {
    if (services.length > 0) {
      setRows(services);
    } else {
      setRows([]);
    }
  }, [services]);

  const onViewService = (applicationId: number) => {
    navigate(`/vista-servicio/${applicationId}`);
  };

  const onEditService = (applicationId: number) => {
    navigate(`/editar-servicio/${applicationId}`);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = (idService: number, name: string) => {
    setSelectedService({ id: idService, name });
    setDeleteModal(true);
  };

  const handleOpenReactivateModal = (idService: number, name: string) => {
    setSelectedService({ id: idService, name });
    setReactivateModal(true);
  };

  const handleCloseModal = () => {
    setDeleteModal(false);
    setReactivateModal(false);
    setSelectedService(null);
  };

  const handleModalAccept = async () => {
    if (selectedService) {
      onDeleteApp(selectedService.id);
      setDeleteModal(false);
      setReactivateModal(false);
      setSelectedService(null);
    }
  };

  return (
    <section className={classes.root}>
      {deleteModal && (
        <Modal
          open={deleteModal}
          onClose={() => setDeleteModal(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          className={classes.modal}
        >
          <Box className={classes.modalContent}>
            <img
              src={IconCancel}
              className={classes.modalIcon}
              alt="eliminar"
            ></img>
            <Typography id="modal-title" className={classes.modalTitle}>
              Desactivar servicio
            </Typography>
            <Typography
              id="modal-subtitle"
              className={classes.modalDescription}
            >
              ¿Deseas confirmar la inactivación del servicio?
            </Typography>
            <Typography className={classes.modalService}>
              {`ID ${selectedService?.id} - ${selectedService?.name}`}
            </Typography>

            <div className={classes.modalButtons}>
              <Button
                className={classes.modalCancel}
                onClick={() => handleCloseModal()}
              >
                Cerrar
              </Button>
              <Button
                className={classes.modalAccept}
                onClick={() => handleModalAccept()}
              >
                Confirmar
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      {reactivateModal && (
        <Modal
          open={reactivateModal}
          onClose={() => setReactivateModal(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          className={classes.modal}
        >
          <Box className={classes.modalContent}>
            <img
              src={IconReactivate}
              className={classes.modalIcon}
              alt="eliminar"
            ></img>
            <Typography id="modal-title" className={classes.modalTitle}>
              Reactivar servicio
            </Typography>
            <Typography
              id="modal-subtitle"
              className={classes.modalDescription}
            >
              ¿Deseas confirmar la Activación del servicio?
            </Typography>
            <Typography className={classes.modalService}>
              {`ID ${selectedService?.id} - ${selectedService?.name}`}
            </Typography>

            <div className={classes.modalButtons}>
              <Button
                className={classes.modalCancel}
                onClick={() => handleCloseModal()}
              >
                Cerrar
              </Button>
              <Button
                className={classes.modalReactivate}
                onClick={() => handleModalAccept()}
              >
                Confirmar
              </Button>
            </div>
          </Box>
        </Modal>
      )}
      <TableContainer component={Paper} style={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell component="th" style={{ width: 20 }}>
                ID
              </TableCell>
              <TableCell component="th">Nombre</TableCell>
              <TableCell component="th" align="center" style={{ width: 140 }}>
                Muestra Mobile
              </TableCell>
              <TableCell component="th" align="center" style={{ width: 140 }}>
                Muestra Panel
              </TableCell>
              <TableCell component="th" align="center" style={{ width: 160 }}>
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentRows.map((row) => (
              <TableRow key={row.id}>
                {/* ID */}
                <TableCell>{row.id}</TableCell>
                {/* Nombre */}
                <TableCell>{row.nombre}</TableCell>
                {/* Muestra Mobile */}
                <TableCell align="center">
                  <IOSSwitch
                    name={`servicios[${row.id}].muestraMovil`}
                    onChange={() =>
                      onChangeMuestraMobile(row.id, !row.muestraMovil)
                    }
                    checked={row.muestraMovil}
                    disabled={row?.fechaBaja !== null}
                  />
                </TableCell>
                {/* Muestra Panel */}
                <TableCell align="center">
                  <IOSSwitch
                    name={`servicios[${row.id}].muestraPanel`}
                    onChange={() =>
                      onChangeMuestraPanel(row.id, !row.muestraPanel)
                    }
                    checked={row.muestraPanel}
                    disabled={row?.fechaBaja !== null}
                  />
                </TableCell>
                {/* Acciones */}
                <TableCell align="center">
                  {row?.fechaBaja !== null ? (
                    <IconButton
                      onClick={() => {
                        handleOpenReactivateModal(row.id, row.nombre);
                      }}
                      style={{ width: 24, height: 24 }}
                    >
                      <ReactivateIcon />
                    </IconButton>
                  ) : (
                    <div className={classes.buttonContent}>
                      <IconButton
                        onClick={() => {
                          onViewService(row.id);
                        }}
                        style={{ width: 24, height: 24 }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          onEditService(row.id);
                        }}
                        style={{
                          width: 24,
                          height: 24,
                          marginRight: 10,
                          marginLeft: 10,
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          handleOpenModal(row.id, row.nombre);
                        }}
                        style={{ width: 24, height: 24 }}
                      >
                        <CancelIcon />
                      </IconButton>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={4} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10]}
                colSpan={6}
                count={rows.length}
                labelDisplayedRows={({ to, count }) => `${to} de ${count}`}
                rowsPerPage={rowsPerPage}
                page={page}
                labelRowsPerPage={!isSmallDevice ? "Filas por página" : ""}
                SelectProps={{
                  inputProps: { "aria-label": "filas por página" },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                style={{ overflowX: "auto" }}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </section>
  );
};

export default connector(
  withStyles(styles)(TableServices)
) as React.ComponentType<PublicProps>;
